import { render, staticRenderFns } from "./NewPwd.vue?vue&type=template&id=16906c58&scoped=true&"
import script from "./NewPwd.vue?vue&type=script&lang=js&"
export * from "./NewPwd.vue?vue&type=script&lang=js&"
import style0 from "./NewPwd.vue?vue&type=style&index=0&lang=less&"
import style1 from "./NewPwd.vue?vue&type=style&index=1&id=16906c58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16906c58",
  null
  
)

export default component.exports